import { RootState } from '../../../../../configuration/setup/store';

export function getTableViewType(state: RootState): string {
    return state.tagsTableToolbar.tableViewType;
}
